<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Budget Request Details</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-check-circle" label="Approve" iconPos="left"  class="p-button-success me-3" (click)="showBasicDialog()" ></button>
        <button pButton type="button" icon="pi pi-times-circle" label="Reject" iconPos="left" class="p-button-danger" (click)="showBasicDialog2()"></button>
    </div>
</div>
    
<div class="row mx-0 budgetRequestDetails">
    <div class="col-12 col-sm-12 col-md-8 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <h4 class="mt-0 mb-4">Budget Request Details</h4>
            <div class="d-flex flex-column mb-4">
                <table class="budgetrequestdetailsTable">
                    <tbody>
                        <tr>
                            <td>Company</td>
                            <td>Idea Factory Outlet</td>
                        </tr>
                        <tr>
                            <td>Department</td>
                            <td>Finance</td>
                        </tr>
                        <tr>
                            <td>Job Type</td>
                            <td>Withholding Tax</td>
                        </tr>
                        <tr>
                            <td>Allocated Amount</td>
                            <td>20,000</td>
                        </tr>
                        <tr>
                            <td>Allocation Type</td>
                            <td>Yearly</td>
                        </tr>
                        <tr>
                            <td>Allocation Type</td>
                            <td>Payments</td>
                        </tr>
                        <tr>
                            <td>Created By</td>
                            <td>Thushara Mahagamage</td>
                        </tr>
                        <tr>
                            <td>Created On</td>
                            <td>2021 Aug 21</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


<p-dialog header="Approve Request" [(visible)]="displayBasic" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <table class="requestedamountTable mb-3" style="width: 100%; border-spacing :0px;">
        <tbody>
            <tr style="background-color:var(--green-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Requested Amount</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">50,000</td>
            </tr>
        </tbody>
    </table>
    <div class="d-flex flex-column mb-3">
        <label class="mb-2">Approved Value</label>
        <input type="text" pInputText> 
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Chain Transaction</label>
        <p-dropdown placeholder="Select Chain Transaction"  optionLabel="name"></p-dropdown>
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Remarks</label>
        <textarea rows="5" cols="30" pInputTextarea></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" icon="pi pi-check-circle" label="Approve" iconPos="left"  class="p-button-success me-3" ></button>
        <button pButton type="button" label="Cancel"  class="p-button-outlined"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Reject Request" [(visible)]="displayBasic2" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <table class="requestedamountTable mb-3" style="width: 100%; border-spacing :0px;">
        <tbody>
            <tr style="background-color:var(--green-50);">
                <td style="padding:12px; font-size: 14px; width: 50%;">Requested Amount</td>
                <td style="padding:12px; font-size: 14px; width: 50%;">50,000</td>
            </tr>
        </tbody>
    </table>
    <div class="d-flex flex-column mb-3">
        <label class="mb-2">Approved Value</label>
        <input type="text" pInputText> 
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Chain Transaction</label>
        <p-dropdown placeholder="Select Chain Transaction"  optionLabel="name"></p-dropdown>
    </div>
    <div class="d-flex flex-column mb-4">
        <label class="mb-2">Remarks</label>
        <textarea rows="5" cols="30" pInputTextarea></textarea>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" icon="pi pi-check-circle" label="Reject" iconPos="left"  class="p-button-danger me-3" ></button>
        <button pButton type="button" label="Cancel"  class="p-button-outlined"></button>
    </ng-template>
</p-dialog>